<app-confirmation-dialog
  [testId]="'order-details-dialog'"
  [(visible)]="visible"
  [title]="'purchase_order.confirm_vendor.order_details_title' | translate"
  [width]="'1400px'"
  [hasCustomContent]="true"
  [buttons]="[]"
  (visibleChange)="visibleChange.emit($event)"
  (emitOnClick)="onHide()"
>
  <div class="order-details-dialog">
    <div class="mb-4">
      <span class="text-sm font-medium text-gray-800">
        {{ "purchase_order.confirm_vendor.warehouse" | translate }}:
      </span>
      <span class="text-sm font-semibold text-gray-800 ml-2">
        {{ warehouseName }}
      </span>
    </div>
    <app-data-table
      data-testid="order-details-dialog-table"
      [dataSource]="orderItems"
      [columns]="tableColumns"
      [loading]="false"
      [rows]="20"
      [totalRecords]="orderItems.length"
      [first]="0"
      class="text-sm"
    ></app-data-table>
  </div>
</app-confirmation-dialog>
